import React, { useState } from 'react';
import Generator from './Generator';
import LanguageSelect from './LanguageSelect';
import ModelSelect from './ModelSelect';

const BlogGenerator = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const formFields = [
        LanguageSelect(),
        {
            id: 'tone',
            type: 'select',
            label: 'Tone',
            defaultValue: 'Friendly',
            options: [
                { value: 'Friendly', label: 'Friendly' },
                { value: 'Inspirational', label: 'Inspirational' },
                { value: 'Entertaining', label: 'Entertaining' },
                { value: 'Persuasive', label: 'Persuasive' },
                { value: 'Analytical', label: 'Analytical' },
                { value: 'Educational', label: 'Educational' },
                { value: 'Narrative', label: 'Narrative' },
                { value: 'Professional', label: 'Professional' }
            ]
        },
        {
            id: 'style',
            type: 'select',
            label: 'Style',
            defaultValue: 'Informative',
            options: [
                { value: 'Informative', label: 'Informative' },
                { value: 'Promotional', label: 'Promotional' },
                { value: 'How-to Guide', label: 'How-to Guide' },
                { value: 'Case Study', label: 'Case Study' },
                { value: 'Product Review', label: 'Product Review' },
                { value: 'Opinion Piece', label: 'Opinion Piece' }
            ]
        },
        {
            id: 'length',
            type: 'select',
            label: 'Length',
            defaultValue: 'medium',
            options: [
                { value: 'short', label: 'Short (~300 words)' },
                { value: 'medium', label: 'Medium (~700 words)' },
                { value: 'long', label: 'Long (~1500 words)' }
            ]
        },
        ModelSelect({ setIsLoading, setError })
    ];

    return (
        <Generator
            title={<><span className="highlight">YT</span> to Blog article</>}
            icon="fas fa-newspaper icon"
            formFields={formFields}
            generateEndpoint="/generate/youtube_article"
            transformFormData={(data) => ({
                url: data.url,
                language: data.language,
                tone: data.tone,
                style: data.style,
                length: data.length,
                model: data.model,
                long: false
            })}
            skipSubscriptionCheck={true}
        />
    );
};

export default BlogGenerator; 